import API_URL from '../config';

/**
 * Get public platform statistics
 * @returns {Promise<Object>} Platform stats
 */
// eslint-disable-next-line import/prefer-default-export
export const getPublicStats = async () => {
  const response = await fetch(`${API_URL}/api/stats/public`);

  if (!response.ok) {
    throw new Error('Failed to fetch stats');
  }

  return response.json();
};
